// extracted by mini-css-extract-plugin
module.exports = {"container":"AsideSubMenu-module__container","openSubMenu":"AsideSubMenu-module__openSubMenu"};